import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, CircularProgress, Typography } from '@mui/material';
import { getActiveVendors } from '../../api/api';

export default function VendorSelection({ selectedVendor, onVendorChange, fullWidth = false, disabled = false }) {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await getActiveVendors();
        if (!cancelled) setVendors(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setVendors([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <Box sx={{ mb: fullWidth ? 0 : 3, px: fullWidth ? 0 : 2, mt: 0 }}>
      <Typography
        variant="subtitle1"
        sx={{ mb: 1.5, fontWeight: 600, textAlign: fullWidth ? 'left' : 'center' }}
      >
        Vendor
      </Typography>
      <FormControl
        fullWidth
        size="small"
        sx={{
          maxWidth: fullWidth ? '100%' : 400,
          mx: fullWidth ? 0 : 'auto',
          display: 'block',
        }}
      >
        <InputLabel>Vendor</InputLabel>
        <Select
          value={selectedVendor}
          label="Vendor"
          onChange={(e) => onVendorChange(e.target.value)}
          disabled={loading || disabled}
          sx={{ width: '100%' }}
        >
          {loading && <MenuItem disabled><CircularProgress size={16} sx={{ mr: 1 }} /> Loading...</MenuItem>}
          {!loading && <MenuItem value=""><em>Select a vendor</em></MenuItem>}
          {vendors.map((v) => (
            <MenuItem key={v.id} value={v.slug}>{v.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
